import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ALL_INTEGRATION_PROVIDERS = gql`
  query fetchAllIntegrationProviders($input: FetchIntegrationsInput!) {
    fetchIntegrations(input: $input) {
      integrations {
        type
        provider
        organization {
          id
        }
      }
      totalCount
    }
  }
`;
export const TRANSITION_INTEGRATION = gql`
  mutation transitionIntegration($input: TransitionIntegrationInput!) {
    transitionIntegration(input: $input) {
      integration {
        id
      }
    }
  }
`;
export const FETCH_INTEGRATIONS = gql`
  query fetchIntegrations($input: FetchIntegrationsInput!) {
    fetchIntegrations(input: $input) {
      integrations {
        id
        configuration
        provider
        type
        state
        scope
        passthroughApiUrl
        passthroughApiPrivateSecretName
        supportedCountries
        organization {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          parent {
            id
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      }
      totalCount
    }
  }
`;
